<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <el-form size="small" ref="form" :model="form" label-width="50px">
      <!--form表单-->
      <el-row :gutter="20">
        <el-col :span="12" style="border-right:1px solid #ddd">
          <el-row>
            <el-col :span="8">
              <div class="common-form">首页主题选择</div>
              <el-form-item label="">
                <el-radio-group v-model="form.home" class="f-w" style="display: flex;flex-direction: column;" @change="change">
                  <el-radio class="mb10 mr10" v-for="item in homethemes" :key="item.id" :label="item.id">{{item.value}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <div class="phone-theme">
                <div v-for="item in homethemes" :key="item.id">
                  <el-image style="width: 300px;height:600px " fit='cover' v-if="item.id==homeid" :src="item.image"></el-image>
                </div>
              </div>
            </el-col>
          </el-row>

        </el-col>
        <el-col :span="12">
          <el-row>
            <el-col :span="8">
              <div class="common-form">我的主题选择</div>
              <el-form-item label="">
                <el-radio-group v-model="form.my" class="f-w" style="display: flex;flex-direction: column;" @change="mychange">
                  <el-radio class="mb10 mr10" v-for="item in mythemes" :key="item.id" :label="item.id">{{item.value}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <div class="phone-theme">
                <div v-for="item in mythemes" :key="item.id">
                  <el-image style="width: 300px;height:600px " fit='cover' v-if="item.id==myid" :src="item.image"></el-image>
                </div>
              </div>
            </el-col>
          </el-row>

        </el-col>
      </el-row>
    </el-form>
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button type="primary" @click="onSubmit" :loading="loading">保存</el-button>
    </div>
  </div>

</template>

<script>
import PageApi from "@/api/page.js";
import Upload from "@/components/file/Upload";
import { formatModel } from "@/utils/base.js";
export default {
  data() {
    return {
      homeid: "",
      myid: "",
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      homethemes: [],
      mythemes: [],
      form: {
        home: "1",
        my: "1"
      },
      /*是否打开图片选择*/
      isupload: false
    };
  },
  created() {
    this.getParams();
  },

  methods: {
    change(e) {
      // console.log("===========", e);
      this.homeid = e;
    },
    mychange(e) {
      // console.log("===========", e);
      this.myid = e;
    },
    /*获取配置数据*/
    getParams() {
      let self = this;
      PageApi.getuserthemes({}, true)
        .then(res => {
          self.form.home = res.data.theme.home * 1;
          self.form.my = res.data.theme.my * 1;
          self.homethemes = res.data.data.home;
          self.homeid = res.data.theme.home * 1;
          self.mythemes = res.data.data.my;
          self.myid = res.data.theme.my * 1;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*提交*/
    onSubmit() {
      let self = this;
      let params = this.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          PageApi.userthemes(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: "恭喜你，设置成功",
                type: "success"
              });
              self.$router.push("/page/usertheme/index");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    }
  }
};
</script>
<style>
.mb10 {
  margin-bottom: 10px;
}

.mr10 {
  margin-right: 10px;
}

.phone-theme > img {
  width: 50%;
  height: auto;
}

.d-c-s {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/page/usertheme/index.vue